var map = {
	"./QDAP-insurance-filled.png": 1462,
	"./home-insurance-filled.png": 1463,
	"./immediate-annuity-insurance-filled.png": 1464,
	"./life-insurance-filled.png": 1465,
	"./long-term-savings-insurance-filled.png": 1466,
	"./medical-insurance-filled.png": 1467,
	"./personal-accident-insurance-filled.png": 1468,
	"./pet-insurance-filled.png": 1469,
	"./short-term-savings-insurance-filled.png": 1470,
	"./term-critical-illness-insurance-filled.png": 1471,
	"./term-life-insurance-filled.png": 1472,
	"./travel-insurance-filled.png": 1473,
	"./whole-life-critical-illness-insurance-filled.png": 1474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2483;